import i18next from 'i18next';

i18next.addResources('es', 'investmentProgress', {
  investmentByStage: 'Inversión por etapas'
});

i18next.addResources('en', 'investmentProgress', {
  investmentByStage: 'Investment by stages'
});

i18next.addResources('pt', 'investmentProgress', {
  investmentByStage: 'Investimento por etapas'
});
